import { type StepperStep } from '@fiverr-private/navigation';
import { STEP_SLUGS } from '@fiverr-private/store_builder_types';
import { STEP_GROUPS } from '../../lib/constants/steps';
import { STEP_GROUPS_STEPPER_CONFIG } from '../constants/stepGroups';
import { getStepGroup } from '../../lib/utils/stepCalculator/stepUtils';

export const calculateStepperData = (currentStepNumber: number): StepperStep[] => {
    const currentStepSlug = STEP_SLUGS[currentStepNumber];
    const currentStepGroups = getStepGroup(currentStepSlug);

    return STEP_GROUPS_STEPPER_CONFIG.map((step) => ({
        ...step,
        completed: step.id <= STEP_GROUPS.indexOf(currentStepGroups),
    }));
};
